<template>
  <div class="clearfix">
    <a-select
      style="width: 100%"
      placeholder="请选择成员"
      @change="handleChange"
      :size="size"
      labelInValue
    >
      <a-select-option v-for="user in memberlist" :key="user.uid" ><a-avatar :src="user.avatar" style="margin:5px 10px 5px 0"/>{{ user.user_name }}</a-select-option>
    </a-select>
  </div>
</template>

<script>
import { getProjectUserList } from '@/api/project'
import { transferItem } from '@/api/item'

export default {
  name: 'SelectProjectUser',
  data () {
    this.lastFetchId = 0
    return {
      memberlist: [],
      selectedUser: { isNull: true },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      confirmLoading: false,
      mdl: {},
      size: 'default'
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var storedMembers = this.$store.getters.projectUsers
      if (storedMembers.length != 0) this.memberlist = storedMembers
      else {
        const _this = this
        this.$store.dispatch('FetchProjectUsers').then(users => {
          _this.memberlist = users
        })
      }
    },
    handleChange (value) {
      const user = this.selectedUser = {}
      user.uid = value.key
      user.user_name = value.label[1].text
      user.isNull = false
      this.size = 'large'
      this.$emit('search_condition_changed')
    }
  }
}
</script>
